import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSecretariesAffiliationService {
  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  list() {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretaries-organization`,
      { headers: this.getHeaders() }
    );
  }

  listBySecretary(secretary_id: Number) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretaries-organization/secretaries/${secretary_id}`,
      { headers: this.getHeaders() }
    );
  }

  listByOrganization(organization_id: Number) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretaries-organization/organization/${organization_id}`,
      { headers: this.getHeaders() }
    );
  }

  show(secretaryId: string) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretaries-organization/secretaries/${secretaryId}`,
      { headers: this.getHeaders() }
    );
  }

  create(params: any) {
    return this.http.post(
      `${environment.apiUrl}/secretarias-affiliation-secretaries-organization`,
      params,
      { headers: this.getHeaders() }
    );
  }

  update(affiliation_id: string, params: any) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-affiliation-secretaries-organization/${affiliation_id}`,
      params,
      { headers: this.getHeaders() }
    );
  }

  /** 
    update(organizationId: string, locationId: string, params: any ){
        return this.http.put(`${environment.apiUrl}/secretarias-organization/${organizationId}/location/${locationId}`, params, { headers: this.getHeaders() });
    }**/
}
